module.exports = function getResource(label, vars = []) {
    let resources = {
        viewFullSizeLabel: 'Voir en format standard',
        viewDetailsLabel: 'Voir les détails'
    };
    return resources[label];
};
